import {
  GetSearchAnalyticsReportUrlRequest,
  GetClaimsSummaryReportUrlRequest,
  ReportsApi,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getSearchAnalyticsReportUrl = async (startDate: string, endDate: string): Promise<string> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ReportsApi)

  const request: GetSearchAnalyticsReportUrlRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    startDate,
    endDate,
  }

  const reportResponse = await api.getSearchAnalyticsReportUrl(request)

  return reportResponse.urlPath
}

const getClaimsSummaryReportUrl = async (startDate: string, endDate: string): Promise<string> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ReportsApi)

  const request: GetClaimsSummaryReportUrlRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    startDate,
    endDate,
  }

  const reportResponse = await api.getClaimsSummaryReportUrl(request)

  return reportResponse.urlPath
}

export const ReportsServiceAPI = {
  getSearchAnalyticsReportUrl,
  getClaimsSummaryReportUrl,
}
